import { observable, action, makeObservable, runInAction } from "mobx";
import { RootStore } from "./RootStore";
import { apolloClientInstance } from "src/network/apolloClientInstance";
import { GET_COMMON_REALESTATES_CONDMINIUM, GET_COMMON_REALESTATES__CONDMINIUM_IT2 } from "src/api/realestates";
import { CommonRealestatesCondominium } from "src/api/generated/CommonRealestatesCondominium";
import { CommonRealestatesCondominiumIT2 } from "src/api/generated/CommonRealestatesCondominiumIT2";

export interface RealestateCondominium {
    id: string;
    name: string;
    number: string;
    consolidationid?: string;
}

export enum LOADING_TYPE {
    NONE,
    REALESTATES_CONDOMINIUM
}

export class RealestateStore {
    rootStore: RootStore;

    realestatesCondominium: RealestateCondominium[] = [];
    realestatesCondominiumIT2: RealestateCondominium[] = [];

    loadingType: LOADING_TYPE = LOADING_TYPE.NONE;

    error?: {
        title: string;
    } = undefined;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;

        makeObservable(this, {
            realestatesCondominium: observable,
            realestatesCondominiumIT2: observable,

            loadRealestatesCondominium: action
        });
    }

    loadRealestatesCondominium = async (isIT2: boolean) => {
        try {
            if (isIT2) {
                const { data }: { data: CommonRealestatesCondominiumIT2 } =
                    await apolloClientInstance.query<CommonRealestatesCondominiumIT2>({
                        query: isIT2 ? GET_COMMON_REALESTATES__CONDMINIUM_IT2 : GET_COMMON_REALESTATES_CONDMINIUM,
                        fetchPolicy: "no-cache"
                    });

                runInAction(() => {
                    if (isIT2) {
                        this.realestatesCondominiumIT2 = data.common_realestates.flatMap((parent) => [
                            {
                                id: parent.id,
                                number: parent.number,
                                name: parent.name,
                                consolidationid: null
                            },
                            ...parent.realestates_to_consolidation.map((child) => ({
                                id: child.id,
                                number: child.number,
                                name: child.name,
                                consolidationid: child.consolidationid
                            }))
                        ]);
                    }
                });
            } else {
                const { data }: { data: CommonRealestatesCondominium } =
                    await apolloClientInstance.query<CommonRealestatesCondominium>({
                        query: isIT2 ? GET_COMMON_REALESTATES__CONDMINIUM_IT2 : GET_COMMON_REALESTATES_CONDMINIUM,
                        fetchPolicy: "no-cache"
                    });

                runInAction(() => {
                    this.realestatesCondominium = data.common_realestates.map((item) => ({
                        id: item.id,
                        number: item.number,
                        name: item.name
                    }));
                });
            }
        } catch (error) {
            console.error("Error loading realestates:", error);
        }
    };
}
